import api from 'Application/api/api';

const sendEpcOfferFromPortal = async (signal, id) => {
	const response = await api.patch(`/epc-offers/partner/${id}/send-proposal`, {
		signal,
	});

	if (!response || !response.data) {
		return response;
	}

	return {
		...response,
		data: response.data,
	};
};

export default sendEpcOfferFromPortal;
